var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pt-task-order-detail',{staticClass:"pt-task-order-detail__page",attrs:{"id":_vm.id}})
}
var staticRenderFns = []

export { render, staticRenderFns }